import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FileInput, FileInputComponent, FileValidator} from "ngx-material-file-input";
import {delay, first, takeUntil} from "rxjs/operators";
import {Uuid} from "../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {AddressImport} from "../../../shared/interface/address-import";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {AddressImportService} from "../../../shared/services/address-import.service";
import {MatDialogRef} from "@angular/material/dialog";
import {DOCUMENT} from "@angular/common";
import {OckImport} from "../../../shared/interface/ock-import";
import {ReplaySubject} from "rxjs";
import {OckImportService} from "../../../shared/services/ock-import.service";

@Component({
  selector: 'app-ock-import',
  templateUrl: './ock-import.component.html',
  styleUrls: ['./ock-import.component.scss']
})
export class OckImportComponent  implements OnInit, OnDestroy {

  @ViewChild('fileInput') fileInputComponent: FileInputComponent;


  ockImportFormValid = false;
  ockImportForm: FormGroup;
  fileControl: FormControl;
  fileMaxSize = 52428800;
  processingRequest = false;
  formErrors = {};
  ockImport?: OckImport;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private importService: OckImportService,
    public dialogRef: MatDialogRef<OckImportComponent>,
    @Inject(DOCUMENT) private document: Document) {
    this.ockImportForm = fb.group({
      vinImport: fb.control(false),
      nipImport: fb.control(false),
      fileContent: fb.control('', [Validators.required]),
      fileName: fb.control('', [Validators.required]),
      file: this.fileControl = fb.control('', [Validators.required, FileValidator.maxContentSize(this.fileMaxSize)]),
    });
  }

  ngOnInit(): void {
    this.ockImportForm.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      )
      .subscribe(() => {
        this.ockImportFormValid = this.ockImportForm.valid;
        if (!this.ockImportForm.get('vinImport').value && !this.ockImportForm.get('nipImport').value) {
          this.ockImportFormValid = false;
        }
      });

    this.ockImportForm.get('vinImport').valueChanges
      .pipe()
      .subscribe((val) => {
       if (val) {
         this.ockImportForm.get('nipImport').setValue(false);
       }
      });

    this.ockImportForm.get('nipImport').valueChanges
      .pipe()
      .subscribe((val) => {
        if (val) {
          this.ockImportForm.get('vinImport').setValue(false);
        }
      });

    this.fileControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((file: FileInput) => {
        if (!file || file.files.length === 0) {
          this.ockImportForm.get('fileContent').setValue('');
          this.ockImportForm.get('fileName').setValue('');
          return;
        }
        file.files.forEach((fileToRead: File) => {
          const reader = new FileReader();
          reader.readAsDataURL(fileToRead);
          reader.onload = () => {
            this.ockImportForm.get('fileName').setValue(fileToRead.name);
            this.ockImportForm.get('fileContent').setValue(/base64,(.+)/.exec(reader.result.toString())[1]);
          };
        });
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }


  import(): void {
    if (!this.ockImportForm.valid) {
      this.ockImportForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    if (this.processingRequest ){
      return;
    }
    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.ockImportForm, this.formErrors);
    this.formErrors = {};

    this.importService.import(this.ockImportForm.value)
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snack.open('Rozpoczynanie importowania', '', {
          duration: 2000,
        });
        this.dialogRef.close();
        this.processingRequest = false;
        this.loadImport(response.uuid);
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snack.open('Podczas importu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.ockImportForm, this.formErrors);
        }
      })
    ;
  }

  resetFileValue(): void {
    this.fileControl.setValue('');
    this.fileInputComponent.clear();
  }
  cancel(e): void {
    this.dialogRef.close(e);
    return;
  }

  loadImport(importId: string): void {
    // this.importService.getImport(importId)
    //   .pipe(delay(1000))
    //   .subscribe((ockImport: OckImport) => {
    //     this.ockImport = ockImport;
    //
    //     if (ockImport.progress !== 100) {
    //       this.loadImport(ockImport.uuid);
    //     } else {
    //       this.snack.open('Import zakończony prawidłowo', '', {
    //         duration: 2000,
    //       });
    //     }
    //   });
  }
}
